export const transformKeyAndValueToLowerCase = (objectToTransform: Record<string, string>) => {
  return Object.entries(objectToTransform).reduce((agg: Record<string, string>, [key, value]) => {
    agg[key.toLowerCase()] = value.toLowerCase();
    return agg;
  }, {});
};
